import styled from "styled-components";

export const CheckoutWrapper = styled.section`
  margin: 2rem auto;
  min-height: calc(100vh - 224px);

  h3 {
    text-align: center;
    margin-top: 2rem;
  }
`;
